/* import __COLOCATED_TEMPLATE__ from './header.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import templateOnlyComponent from '@ember/component/template-only';
import { type SafeString } from '@ember/template/-private/handlebars';

interface Args {
  intro: string | SafeString;
  setUpFinClick: (section: string) => void;
  shouldShowPersonalized: boolean;
  isDarkMode: boolean;
}

interface Signature {
  Args: Args;
}

const Header = templateOnlyComponent<Signature>();
export default Header;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::FinReadiness::Header': typeof Header;
  }
}
